var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 38.4C2.14904 38.4 0 36.251 0 33.6V4.8C0 2.14904 2.14902 0 4.8 0H33.6C36.251 0 38.4 2.14904 38.4 4.8V16H48C49.7674 16 51.2 17.4326 51.2 19.2V48C51.2 49.7674 49.7674 51.2 48 51.2H19.2C17.4326 51.2 16 49.7674 16 48V38.4H4.8ZM35.2 16H19.2C17.4326 16 16 17.4326 16 19.2V35.2H4.8C3.91634 35.2 3.2 34.4837 3.2 33.6V4.8C3.2 3.91635 3.91635 3.2 4.8 3.2H33.6C34.4837 3.2 35.2 3.91635 35.2 4.8V16Z",
    fill: "#09264D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchIcon);
export default __webpack_public_path__ + "static/media/match-icon.dd302b5cbbaa43425dfc9e1cec3dd04a.svg";
export { ForwardRef as ReactComponent };